import React from 'react';
import { Box, CircularProgress, Tooltip, useTheme } from '@material-ui/core';
import { Check, Close } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';
import { CircleIcon, Typography } from '../../../../ui-kit';
import { RossumUploadStatus } from '../../../../generated/graphql';

interface ReviewStatusIndicatorProps {
    status?: RossumUploadStatus;
}

const ReviewStatusIndicator = ({ status }: ReviewStatusIndicatorProps) => {
    const { t } = useTranslation();
    const theme = useTheme();

    let icon: React.ReactNode;
    let text: React.ReactNode;
    let tooltipText: string;
    if (status === RossumUploadStatus.Importing || status === RossumUploadStatus.ToReview || status === RossumUploadStatus.Reviewing) {
        icon = <CircularProgress size={20} style={{ color: theme.palette.warning.main }} />;
        text = <Typography variant='body2' colorVariant='warning'>{t('Processing')}</Typography>;
        tooltipText = t('We are verifying your data. Please wait.');
    } else if (status === RossumUploadStatus.Confirmed) {
        icon = <CircleIcon isSmall color='success' iconComponent={<Check style={{ fontSize: 14 }} />} />;
        text = <Typography variant='body2' colorVariant='success'>{t('Finished')}</Typography>;
        tooltipText = t('Your data has been verified.');
    } else if (status === RossumUploadStatus.CompletedByUser) {
        icon = <CircleIcon isSmall color='success' iconComponent={<Check style={{ fontSize: 14 }} />} />;
        text = <Typography variant='body2' colorVariant='success'>{t('Completed')}</Typography>;
        tooltipText = t('You created a delivery list from this invoice.');
    } else if (status === RossumUploadStatus.Rejected) {
        icon = <CircleIcon isSmall color='error' iconComponent={<Close style={{ fontSize: 14 }} />} />;
        text = <Typography variant='body2' colorVariant='error'>{t('Rejected')}</Typography>;
        tooltipText = t('This invoice format is not supported.');
    } else {
        icon = <CircleIcon isSmall color='error' iconComponent={<Close style={{ fontSize: 14 }} />} />;
        text = <Typography variant='body2' colorVariant='error'>{t('Failed')}</Typography>;
        tooltipText = t('Error while processing your data. Please try again.');
    }

    return (
        <Tooltip title={tooltipText}>
            <Box display='flex' alignItems='center'>
                {icon}
                <Box ml={1} />
                {text}
            </Box>
        </Tooltip>
    );
};

export default ReviewStatusIndicator;
